import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IPerformExtractEncryptionActionOnWorkbooksParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnWorkbooksRequest extends Request<IPerformExtractEncryptionActionOnWorkbooksParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnWorkbooks', {
      ids: ids,
      type: type
    });
  }
}
